// Wrapper tipado da API REST (docs/04). Sempre same-origin (dev: proxy Vite).
export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number) {
    super(message);
  }
}

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      credentials: 'same-origin',
      headers: init?.body ? { 'Content-Type': 'application/json' } : undefined,
      ...init,
    });
  } catch {
    throw new ApiError('NETWORK', 'sem conexão com o servidor', 0);
  }
  const data = (await res.json().catch(() => ({}))) as { error?: { code: string; message: string } } & T;
  if (!res.ok) {
    throw new ApiError(data.error?.code ?? 'HTTP', data.error?.message ?? `erro ${res.status}`, res.status);
  }
  return data;
}

export interface Session { username: string; points: number }
export interface BoardRow { rank: number; runId: number; username: string; timeMs: number; hasGhost: boolean }

export const api = {
  me: () => req<{ user: Session | null; pbs?: Record<string, number> }>('/auth/me'),
  register: (username: string, password: string, email?: string, guestTimes?: Record<string, number>) =>
    req<{ user: Session; migrated: number }>('/auth/register', {
      method: 'POST', body: JSON.stringify({ username, password, email: email || undefined, guestTimes }),
    }),
  login: (username: string, password: string) =>
    req<{ ok: true }>('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
  logout: () => req<{ ok: true }>('/auth/logout', { method: 'POST' }),
  maps: () => req<{ maps: { slug: string; wr: { username: string; timeMs: number } | null }[] }>('/maps'),
  leaderboard: (slug: string) =>
    req<{ rows: BoardRow[]; myRank: number | null; myTime: number | null }>(`/maps/${slug}/leaderboard`),
  submitRun: (payload: {
    mapSlug: string; timeMs: number; stageTimesMs: number[]; maxSpeed: number; physicsVersion: number; ghost?: string;
  }) =>
    req<{ improved: boolean; rank: number; flagged: boolean; runId: number }>('/runs', { method: 'POST', body: JSON.stringify(payload) }),
  runMeta: (id: number) => req<{ mapSlug: string; username: string; timeMs: number }>(`/runs/${id}`),
};
